import { createSlice } from '@reduxjs/toolkit';

export enum ApplicationModal {
  WALLET,
}

export interface ApplicationState {
  readonly openModal: ApplicationModal | null;
  readonly chainId: number | null;
}

const initialState: ApplicationState = {
  openModal: null,
  chainId: null,
};

const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    setOpenModal(state, action) {
      state.openModal = action.payload;
    },
    updateChainId(state, action) {
      const { chainId } = action.payload;
      state.chainId = chainId;
    },
  },
});

export const { setOpenModal, updateChainId } = applicationSlice.actions;
export default applicationSlice.reducer;
